import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig   } from '@angular/material/dialog';
import { User                         } from 'src/app/beans/login/user/user.bean';
import { Message                      } from 'src/app/beans/message/message.bean';
import { Site                         } from 'src/app/beans/site/site.bean';
import { OrganizationSelect           } from 'src/app/components/select/organization/organization-select/organization.select';
import { SiteSelect                   } from 'src/app/components/select/site/site-select/site.select';
import { CustomColumn, CustomTableComponent                 } from 'src/app/components/table/custom-table/custom-table.component';
import { GenericDialog                } from 'src/app/dialogs/generic/generic.dialog';
import { MessageDialog                } from 'src/app/dialogs/message/message.dialog';
import { DialogsReturnCode            } from 'src/app/enums/dialogs/returnCode.enum';
import { HandlerManager               } from 'src/app/managers/handler/handler.manager';
import { LoadingManager               } from 'src/app/managers/loading/loading.manager';
import { PipeManager } from 'src/app/managers/pipe/pipe.manager';
import { SessionManager               } from 'src/app/managers/session/session.manager';

@Component
({
  selector: 'message.page',
  templateUrl: './message.page.html',
  styleUrls: ['./message.page.scss']
})

export class MessagePage implements OnInit 
{
  orgSelect: OrganizationSelect
  @ViewChild('orgManager') set _orgSelect(orgSelect: OrganizationSelect){
    if (orgSelect){
      this.orgSelect = orgSelect
    }
  }
  site: Site
  @ViewChild('siteManager') set _siteSelect(siteSelect: SiteSelect){
    if (siteSelect){
      this.setSite(siteSelect.getSelectedValue())
    }
  }

  @ViewChild('messageTable') messageTable: CustomTableComponent

  messageColumns: CustomColumn [] = [
    {
      isId    : true,
      label   : "id",
      name    : "id",
      display : ( val : any ) => false ,
    },
    {
      label         : "text",
      name          : "tables.messages.labels.text"
    },
    {
      label         : "dateBegin",
      name          : "tables.messages.labels.dateBegin"
    },
    {
      label         : "dateEnd",
      name          : "tables.messages.labels.dateEnd"
    },
    {
      label         : "level",
      name          : "tables.messages.labels.level"
    },
    {
      label: "target",
      name : "tables.messages.labels.target",
      pipe : (target: any) => this._pipe.tables().is_not_null(target, "-"),
    }
  ]

  values: Message[] = []

  constructor(
    private _handler: HandlerManager,
    private _loader : LoadingManager,
    private _session: SessionManager,
    private _dialog : MatDialog     ,
    private _pipe   : PipeManager   ,
  ) { }

  ngOnInit(): void 
  {

  }

  setSite(site: Site)
  {    
    this.site = site
    this.init()
  }

  //-----------------------------------------------------------------------------

  async init() 
  {
    if ( this.site ) 
    {
      this.values = await this.retriveValues( this.site.id );
    }
  }
  
  //-----------------------------------------------------------------------------
  

  async retriveValues( siteId: number ) 
  {
    const user = this._session.user().get()

    if (!User.isKind(user)) return // TODO handle user incorrect 

    this._loader.start()
    this.messageTable.reloadData()
    let response = null

    response = await this._handler.message().getList((user as User).token, siteId)

    this._loader.stop()
    this.messageTable.dataLoaded()

    if ( !response      ) return
    if ( !response.list ) return

    return response.list as Message[];
  }

  //Delete existing message and refresh table
  delete(item: any, index: number, array: any[])
  {
    this.openDialog( "delete", item )
  }

  //Call Dialog
  async update(item: any, index: number, array: any[])
  {
    let message = await this.getMessageDetail( item.id )
    
    this.openDialog( "update", message )
  }

  //Call Dialog
  create()
  {
    this.openDialog( "create", null )
  }

  async getMessageDetail( messageId: number )
  {
    const user = this._session.user().get()

    if (!User.isKind(user)) return // TODO handle user incorrect 

    this._loader.start()

    const siteid  = this.site.id

    let response = await this._handler.message().getDetail((user as User).token, siteid, messageId)

    this._loader.stop()

    if ( !response        ) return
    if ( !(response as any).object ) return

    return (response as any).object as Message;
  }

  async deleteMessage( siteId: number, messageId: number ) 
  {
    const user = this._session.user().get()

    if (!User.isKind(user)) return // TODO handle user incorrect 

    this._loader.start()

    await this._handler.message().delete((user as User).token, siteId, messageId)

    this._loader.stop()
  }

  //-----------------------------------------------------------------------------

  openDialog( action: string, message: Message )
  {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus    = true;

    const orgid   = this.orgSelect.getSelectedValue().id

    let dialog: any
    if( action && action != "delete" )
    {
      dialogConfig.data = {
        organizationId: orgid    ,
        site          : this.site,
        message       : message
      }

      dialog = this._dialog.open(MessageDialog, dialogConfig);
    }
    else if( action )
    {
      dialog = this._dialog.open(GenericDialog, dialogConfig);
    }
    else return

    dialog.afterClosed().subscribe(async (data: any) =>
    {
      //Delete message and refresh table data
      if (data.code == DialogsReturnCode.OPERATION_ACCEPTED)
      {
        await this.deleteMessage( this.site.id, message.id )
        this.values = await this.retriveValues( this.site.id )
      }

      //Refresh table data
      if (data.code == DialogsReturnCode.MESSAGE_OPERATION_ACCEPTED)
      {
        this.values = await this.retriveValues( this.site.id )
      }
    })
  }
}
